import { useContext } from "react";

import { StatusPopupContext } from "@vega-core/components/StatusPopup/StatusPopupContext";
import { isFalsy } from "@vega-core/utils/isFalsy";

export const useStatusPopup = () => {
  const context = useContext(StatusPopupContext);

  if (isFalsy(context)) {
    throw new Error("useStatusPopup must be used within a StatusPopupProvider");
  }

  return context;
};
